import React, { useState, useEffect, useRef } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as actionCreators from "../../actions/newGasContract";
import _ from "lodash";

import { Step, Stepper, StepLabel, Box, Typography } from "@material-ui/core";

import Settings from "../../settings";
import { collectFormData } from "./form-data";
import { sendGasLeads } from "../../utils/http_functions";
import { i18n } from "../../config";

import FormAboutHome from "./FormAboutHome";
import FormAboutYou from "./FormAboutYou";
import FormPayment from "./FormPayment";
import FormAboutContract from "./FormAboutContract";
import Confirm from "./Confirm";
import Confirmed from "./Confirmed";

function mapStateToProps(state) {
  return {
    authType: state.auth.type,
    isAuthenticated: state.auth.isAuthenticated,
    ...state.newGasContract,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(actionCreators, dispatch);
}

const NewGasContract = (props) => {

  const stepLimit = 6;
  const [index, setIndex] = useState(1);
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  const updateWindowDimensions = () => {
    setScreenWidth(window.innerWidth);
  }
  useEffect(() => {
    window.addEventListener("resize", updateWindowDimensions);
    return () => window.removeEventListener("resize", updateWindowDimensions);
  }, []);

  const stepTabs = (
    <Stepper activeStep={index - 1} orientation={screenWidth > 996 ? "horizontal" : "vertical" }>
      <Step>
        <StepLabel>{i18n.t('common:text.contractation_about_home')}</StepLabel>
      </Step>
      <Step>
        <StepLabel>{i18n.t('common:text.contractation_about_you')}</StepLabel>
      </Step>
      <Step>
        <StepLabel>{i18n.t('common:text.contractation_about_gas_contract')}</StepLabel>
      </Step>
      <Step>
        <StepLabel>{i18n.t('common:text.contractation_about_payment')}</StepLabel>
      </Step>
      <Step>
        <StepLabel>{i18n.t('common:text.contractation_confirmation')}</StepLabel>
      </Step>
      <Step>
        <StepLabel>{i18n.t('common:text.contractation_confirmed')}</StepLabel>
      </Step>
    </Stepper>
  );

  const handleSubmit = () => {
    if (index < stepLimit) {
      setIndex(index + 1);
    }
  };

  const handleGoBack = () => {
    if (index !== 1) {
      setIndex(index - 1);
    }
  };

  const steps = [
    { leadIndex: 1, content: <FormAboutHome onSubmit={handleSubmit} /> },
    {
      leadIndex: 2,
      content: (
        <FormAboutYou
          onGoBack={handleGoBack}
          onSubmit={handleSubmit}
        />
      ),
    },
    {
      leadIndex: 3,
      content: (
        <FormAboutContract onGoBack={handleGoBack} onSubmit={handleSubmit} />
      ),
    },
    {
      leadIndex: 4,
      content: <FormPayment onGoBack={handleGoBack} onSubmit={handleSubmit} />,
    },
    {
      leadIndex: 5,
      content: <Confirm onGoBack={handleGoBack} onSubmit={handleSubmit} />,
    },
    { leadIndex: 5, content: <Confirmed onGoBack={handleGoBack} /> },
  ];

  useEffect(() => {
    props.fetchContractationConfig();
    // eslint-disable-next-line
  }, []);

  const usePrevious = (value) => {
    const ref = useRef();
    useEffect(() => {
      ref.current = value;
    });
    return ref.current;
  };

  const prevIndex = usePrevious(index);

  useEffect(() => {
    const leadIndex = steps[index - 1].leadIndex;

    if (
      _.get(Settings, "features.leads", false) &&
      props.leadsConsent &&
      index !== stepLimit &&
      leadIndex &&
      prevIndex < index
    ) {
      const formData = collectFormData(props);
      formData.step = index;
      sendGasLeads(formData);
    }

    // Confirm
    if (index === stepLimit) {
      console.log("props confirm", props);
      const formData = collectFormData(props);
      props.confirmNewContract({ ...formData, step: index, confirm: true });
    }
    // eslint-disable-next-line
  }, [index]);

  const stepContent = () => {
    return steps[index - 1].content;
  };

  return (
    <div className="form-contractation">
      <Box>
        <Typography variant="h4">
          {i18n.t('common:text.contractation_gas_title')}
        </Typography>
      </Box>
      {stepTabs}
      {stepContent()}
    </div>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(NewGasContract);
